import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const DetailsMainContainerBlock = styled.div`
    display: flex;
    flex-direction: column;
`;

export const AdjustmentContianer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    ${media.mobileDevice`
        width: 98%;
        margin: 0px auto;
        padding: ${({ mbPadding }) => mbPadding};
    `}
`;

export const CreditContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    ${media.mobileDevice`
        flex-direction: column;
        width: 100%;
        align-items: flex-start;
    `}
`;

export const CreditDataContiner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 10px;
`;

export const CreditFonts = styled.p`
    margin: 0;
    display: inline-block;
    font-family: ${({ creditHeader }) =>
        creditHeader ? 'AvenirNextWorld Demi' : 'AvenirNextWorld Regular'};
    font-size: ${({ creditHeader }) => (creditHeader ? '14px' : '15px')};
    line-height: 20px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    margin-bottom: 5px;
`;

export const AdjustmentSummary = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin: ${({ margin }) => (margin ? margin : '0')};
`;

export const AdjustmentSummaryDataContiner = styled.div`
    display: flex;
    width: 100%;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'flex-start'};
`;

export const AdjustmentSummaryFont = styled.p`
    margin: 0;
    display: inline-block;
    font-family: ${({ grossAmount }) =>
        grossAmount ? 'AvenirNextWorld Demi' : 'AvenirNextWorld Regular'};
    font-size: ${({ grossAmount }) => (grossAmount ? '16px' : '15px')};
    letter-spacing: -0.12px;
    color: #4f4f4f;
    opacity: 1;
    line-height: 23px;
`;
export const Type = styled.span`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: inline;
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 5px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 1;
    font-size: 13px;
`;

export const AdjustmentProductContainer = styled.div`
    display: flex;
    margin: ${({ margin }) => (margin ? margin : '0')};
    width: 100%;
    height: 100%;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'row'};
    justify-content: ${({ justifyContent }) => justifyContent};
    align-items: ${({ alignItems }) => alignItems};
`;

export const DesktopInvoiceButtonContainer = styled.div`
    display: flex;
    width: 50%;
    margin-bottom: 10px;
    ${media.mobileDevice`
        display: none;
    `}
`;
export const MobileInvoiceButtonConainer = styled.div`
    display: none;
    width: 100%;
    ${media.mobileDevice`
        display: flex;
        margin-bottom: 10px;
    `}
`;
export const AdjustmentContentWrapper = styled.div`
    width: 100%;
    margin: ${({ margin }) => (margin ? margin : '0 0 15px 0')};
`;
